import React from 'react'
import styled from 'styled-components'

import { breakpoint, getColor } from '../../shared/theme'

import Blockquote from '../../elements/typography/blockquote'
import H6 from '../../elements/typography/h6'
import SinglePostInner from '../../elements/singlePostInner'

const Intro = styled.div`
	background: ${getColor('greyLight')};
	padding: 48px 0 69px;

	@media ${breakpoint('tablet')} {
		padding: 120px 0 148px;
	}
`

const IntroCopy = styled(Blockquote)`
	font-weight: 700;
	grid-column: -1 / 1;

	@media ${breakpoint('tablet')} {
		grid-column: span 9;
	}

	@media ${breakpoint('desktop')} {
		grid-column: span 7;
	}

	p {
		font: inherit;
	}
`

const Category = styled(H6)`
	display: inline-flex;
	position: relative;
	align-items: center;
	text-transform: uppercase;
	grid-column: -1 / 1;
	margin-bottom: 40px;
	letter-spacing: 0.25px;
	font-weight: 700;

	&::before {
		content: '';
		display: inline-block;
		height: 4px;
		width: 45px;
		margin-right: 16px;
		flex-shrink: 0;
		background: ${getColor('black')};
	}

	@media ${breakpoint('tablet')} {
		margin-bottom: 40px;
	}
`

const PostIntro = ({ categories, copy }) => {
	return (
		<Intro>
			<SinglePostInner>
				{categories && (
					<Category>
						{categories.nodes.map((category, index) => {
							return index < categories.nodes.length - 1
								? `${category.name} & `
								: `${category.name}`
						})}
					</Category>
				)}
				{copy && <IntroCopy dangerouslySetInnerHTML={{ __html: copy.copy }} />}
			</SinglePostInner>
		</Intro>
	)
}

export default PostIntro
